// extracted by mini-css-extract-plugin
export default {"container":"bF-z","header":"cF-z","details":"dF-z","link":"eF-z"};